import api from '../axios';
import { ENDPOINT_DEV } from '../configs';

export const deleteConnectionByIdApi = async (sessionId: string, message: string, org_id: string) => {
  return await api.delete(ENDPOINT_DEV + 'booking/' + sessionId + `?org_id=${org_id}`, { data: { message: message } }).then((res) => {
    return res;
  });
};
